import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      // Data stays fresh for 5s to prevent instant background refetches
      // when navigating between pages. Keeps the UI feeling snappy.
      staleTime: 5_000,
      // Keep inactive data in cache for 5 minutes
      gcTime: 5 * 60_000,
    },
  },
})
